/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ActiveAlertResponse,
    ActiveAlertResponseFromJSON,
    ActiveAlertResponseToJSON,
} from '../models/ActiveAlertResponse';
import {
    type AlertRuleResponse,
    AlertRuleResponseFromJSON,
    AlertRuleResponseToJSON,
} from '../models/AlertRuleResponse';
import {
    type CreateAlertRuleRequest,
    CreateAlertRuleRequestFromJSON,
    CreateAlertRuleRequestToJSON,
} from '../models/CreateAlertRuleRequest';

export interface AcknowledgeAlertRequest {
    /**
     * Alert ID
     */
    id: string;
}

export interface CreateRuleRequest {
    /**
     * 
     */
    createAlertRuleRequest: CreateAlertRuleRequest;
}

export interface GetActiveAlertsRequest {
    /**
     * Filter by machine ID
     */
    machineId?: string;
}

export interface GetRulesRequest {
    /**
     * Filter by machine ID
     */
    machineId?: string;
}

export interface ResolveAlertRequest {
    /**
     * Alert ID
     */
    id: string;
}

/**
 * 
 */
export class AlertsApi extends runtime.BaseAPI {

    /**
     * Creates request options for acknowledgeAlert without sending the request
     */
    async acknowledgeAlertRequestOpts(requestParameters: AcknowledgeAlertRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling acknowledgeAlert().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/alerts/{id}/acknowledge`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Marks an active alert as acknowledged. Sets the acknowledgedAt timestamp. This is an idempotent operation — acknowledging an already-acknowledged alert returns the same result.
     * Acknowledge an alert
     */
    async acknowledgeAlertRaw(requestParameters: AcknowledgeAlertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveAlertResponse>> {
        const requestOptions = await this.acknowledgeAlertRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveAlertResponseFromJSON(jsonValue));
    }

    /**
     * Marks an active alert as acknowledged. Sets the acknowledgedAt timestamp. This is an idempotent operation — acknowledging an already-acknowledged alert returns the same result.
     * Acknowledge an alert
     */
    async acknowledgeAlert(requestParameters: AcknowledgeAlertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveAlertResponse> {
        const response = await this.acknowledgeAlertRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createRule without sending the request
     */
    async createRuleRequestOpts(requestParameters: CreateRuleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createAlertRuleRequest'] == null) {
            throw new runtime.RequiredError(
                'createAlertRuleRequest',
                'Required parameter "createAlertRuleRequest" was null or undefined when calling createRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/alerts/rules`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAlertRuleRequestToJSON(requestParameters['createAlertRuleRequest']),
        };
    }

    /**
     * Creates a new alert rule for a machine. Supports THRESHOLD, TREND, and CONSECUTIVE_FAILURES condition types. The rule is active immediately upon creation.
     * Create a new alert rule
     */
    async createRuleRaw(requestParameters: CreateRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AlertRuleResponse>> {
        const requestOptions = await this.createRuleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AlertRuleResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new alert rule for a machine. Supports THRESHOLD, TREND, and CONSECUTIVE_FAILURES condition types. The rule is active immediately upon creation.
     * Create a new alert rule
     */
    async createRule(requestParameters: CreateRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AlertRuleResponse> {
        const response = await this.createRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getActiveAlerts without sending the request
     */
    async getActiveAlertsRequestOpts(requestParameters: GetActiveAlertsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['machineId'] != null) {
            queryParameters['machineId'] = requestParameters['machineId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/alerts/active`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieves all active alerts that have not been resolved. Optionally filter by machineId.
     * Get active (unresolved) alerts
     */
    async getActiveAlertsRaw(requestParameters: GetActiveAlertsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveAlertResponse>> {
        const requestOptions = await this.getActiveAlertsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveAlertResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all active alerts that have not been resolved. Optionally filter by machineId.
     * Get active (unresolved) alerts
     */
    async getActiveAlerts(requestParameters: GetActiveAlertsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveAlertResponse> {
        const response = await this.getActiveAlertsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getRules without sending the request
     */
    async getRulesRequestOpts(requestParameters: GetRulesRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['machineId'] != null) {
            queryParameters['machineId'] = requestParameters['machineId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/alerts/rules`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieves all configured alert rules. Optionally filter by machineId.
     * Get all alert rules
     */
    async getRulesRaw(requestParameters: GetRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AlertRuleResponse>> {
        const requestOptions = await this.getRulesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AlertRuleResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all configured alert rules. Optionally filter by machineId.
     * Get all alert rules
     */
    async getRules(requestParameters: GetRulesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AlertRuleResponse> {
        const response = await this.getRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resolveAlert without sending the request
     */
    async resolveAlertRequestOpts(requestParameters: ResolveAlertRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resolveAlert().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/alerts/{id}/resolve`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Marks an active alert as resolved. Sets the resolvedAt timestamp. Resolved alerts will no longer appear in the active alerts list. This is an idempotent operation — resolving an already-resolved alert returns the same result.
     * Resolve an alert
     */
    async resolveAlertRaw(requestParameters: ResolveAlertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActiveAlertResponse>> {
        const requestOptions = await this.resolveAlertRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActiveAlertResponseFromJSON(jsonValue));
    }

    /**
     * Marks an active alert as resolved. Sets the resolvedAt timestamp. Resolved alerts will no longer appear in the active alerts list. This is an idempotent operation — resolving an already-resolved alert returns the same result.
     * Resolve an alert
     */
    async resolveAlert(requestParameters: ResolveAlertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActiveAlertResponse> {
        const response = await this.resolveAlertRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
